(function() {
	
	const _endpoint = 'https://api.mapbox.com/mapbox-gl-js';
	const _version = 'v2.14.1';
	const _script = 'mapbox-gl.js';
	const _stylesheet = 'mapbox-gl.css';
	
	
	class Mapbox extends HTMLElement 
	{
		
		#wrapper;
		#map;
		#name;
		
		
		static get observedAttributes() {
			return ['lat', 'lng', 'mapstyle', 'zoom', 'apikey', 'markers'];
		}
		
		
		
		_fileUri(type) {
			let pathNames = [ _endpoint, _version ];
			if( type === 'script' ) {
				pathNames.push(_script);
			}
			else if( type === 'stylesheet' ) {
				pathNames.push(_stylesheet);
			}
			else {
				throw new Error("type argument is not valid");
			}
			return pathNames.join('/');
		}
		
		
		
		
		/* 
		 * The element's constructor is run anytime a new instance is created. 
		 * Instances are created either by parsing HTML, calling 
		 * document.createElement('howto-checkbox'), or calling new HowToCheckbox(); 
		 * The constructor is a good place to create shadow DOM, though you should 
		 * avoid touching any attributes or light DOM children as they may not be available yet.
		 */
		constructor() 
		{
			super();
	
			this.#name = `mapboxgl-${new Date().getTime()}`;
			
			const shadow = this.attachShadow({ mode: 'open' });
			this.#wrapper = this.getMarkup();
			
			const scripts = document.createElement('script');
			scripts.src = this._fileUri('script');
			scripts.onload = () => this.initMap();
			
			const styles = document.createElement('link');
			styles.rel = 'stylesheet';
			styles.type = 'text/css';
			styles.href = this._fileUri('stylesheet');
			
			const innerStyles = this.getStyles();
			
			shadow.appendChild(this.#wrapper);
			shadow.appendChild(styles);
			shadow.appendChild(innerStyles);
			shadow.appendChild(scripts);
			
			//this._onClick = this._onClick.bind(this);
			//this._onClose = this._onClose.bind(this);
		}
		
		

		
		
		
		
		
		/*
		 * connectedCallback() fires when the element is inserted into the DOM. 
		 * It's a good place to set the initial role, tabindex, internal state, and install event listeners.
		 * 
		 * A user may set a property on an instance of an element, before its prototype has been connected to this class. 
		 * The _upgradeProperty() method will check for any instance properties and run them through 
		 * the proper class setters. See the lazy properties section for more details.
		 */
		connectedCallback() 
		{
			//const _this = this;
			//const shadow = this.shadowRoot;
		}
		
		
		initMap() 
		{
			mapboxgl.accessToken = this.apikey;
			
			let params = {
				container: this.#wrapper,
				center: [this.lng, this.lat],
				zoom: this.zoom,
			};
			
			
			if( this.style ) {
				params.style = `mapbox://styles/mapbox/${this.mapstyle}`;
			}
			
			this.#map = new mapboxgl.Map(params);
			
			
			const markers = this.markers;
			
			markers.forEach(marker => {
				if( marker.lat && marker.lng ) {
					//const m = 
					new mapboxgl.Marker({ color: marker.color || 'black' })
						.setLngLat([ marker.lng, marker.lat ])
						.addTo(this.#map);
				}
			});
		}
		
		
		
		
		
		/* 
		 * disconnectedCallback() fires when the element is 
		 * removed from the DOM. 
		 * It's a good place to do clean up work like releasing 
		 * references and removing event listeners.
		 */
		disconnectedCallback() 
		{
			//const shadow = this.shadowRoot;
			//shadow.querySelector('.txn--close').removeEventListener('click', this._onClose);
			//this.removeEventListener('click', this._onClick);
		}
		
		
		
		getMarkup() 
		{
			//const _this = this;
			const wrapper = document.createElement('div');
			wrapper.id = this.#name;
			return wrapper;
		}
		

		
		
		
		get lat() 
		{
			return this.getAttribute('lat') || '';
		}
		
		get lng() 
		{
			return this.getAttribute('lng') || '';
		}
		
		get zoom() 
		{
			return this.getAttribute('zoom') || 9;
		}
		
		get mapstyle() 
		{
			return this.getAttribute('mapstyle') || '';
		}
		
		get apikey() 
		{
			return this.getAttribute('apikey') || '';
		}
		
		
		get markers() 
		{
			try {
				const markers = JSON.parse(this.getAttribute('markers'));			
				if( Array.isArray(markers) ) {
					return markers;
				}
				return [];
			}
			catch(e) {
				return [];
			}
		}
		
		/*
		get class() 
		{
			return this.getAttribute('class') || 9;
		}
		
		
		get id() 
		{
			return this.getAttribute('id');
		}
		*/

		
		
		
		
		
		
		getStyles() 
		{
			const style = document.createElement('style');
			style.textContent = `
				:host {
					display:block;
					margin:0;
					border:0;
					padding:0;
					box-sizing:border-box;
				}
				
				:host([disabled]) {
					opacity:.5;
				}
				
				#${this.#name} {
					width:100%;
					height:100%;
				}
			`;
			
			return style;
		}
	}
	
	
	window.customElements.define('mapbox-gl', Mapbox);
})();
